import {axios as http} from "@/plugins/http"

export default class Api {
    static getPoint(ids, typeId) {
        return http.post("/api/v1/post/rating", {
            post_ids: ids,
            type_id: typeId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }
}
